import React, { Component } from 'react';
import { List, Create, Update } from './graphql.js';
import EventsComponent from '../../components/Events';
import { nullsToStrings, updateInPath } from '../../../../common/utils';
import { getList, setItem } from '../../../common/utils';
import { clone } from 'ramda';

// BEGIN config
// TODO: would like to get rid of this. Move to form or sth.
const BLANK = {
  title: '',
  beginDate: '',
  endDate: '',
  type: 'COMPETITION',
  location: '',
  registrationEnabled: false,
  published: false,
  i18n_description: {}
};


// END config

export default class Events extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      loading: false,
      modal: {
        data: {},
        opened: false,
        save : {
          enabled: false
        }
      }
    };
  }
 
  fetchData = async () => {
    this.setState(s => updateInPath(s, 'loading', true));
    const data = await getList('listEvents', { query: List });
    this.setState(s => updateInPath(s, 'data', data));
    this.setState(s => updateInPath(s, 'loading', false));
  }

  handleModalOpen = (e, item) => {
    if (!this.state.modal.opened) {
      this.setState(prevState => {
        const newState = clone(prevState);
        newState.modal.opened = true;
        newState.modal.data =  (e ? clone(BLANK) : nullsToStrings(item));
        newState.modal.save.enabled = false;
        return newState;
      });
    }
  }

  handleModalClose = (refreshData) => {
    if (this.state.modal.opened) {
      this.setState(prevState => {
        const newState = clone(prevState);
        newState.modal.opened = false;
        newState.modal.data = clone(BLANK);
        newState.modal.save.enabled = false;
        return newState;
      });

      if (refreshData) {
        this.fetchData();
      }
    }
  }

  handleModalSave = async (data) => {
    const d = clone(data);

    // event type cannot be changed
    if (d.id) {
      delete d.type;
    }

    this.setState(s => updateInPath(s, 'modal.opened', false));
    await setItem((data.id ? Update : Create), d);
    this.fetchData();
  }
  
  componentDidMount() {
    this.fetchData();
  }

  render() {
    const { modal, data, loading } = this.state;

    return (
      <EventsComponent
        data={data}
        modal={modal}
        loading={loading}
        onSave={this.handleModalSave}
        onClose={this.handleModalClose}
        onOpen={this.handleModalOpen}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/containers/Events/index.js